// Credit: https://dev.to/elsyng/react-modal-dialog-using-html-dialog-element-5afk
import React, { MouseEvent, useEffect, useRef } from 'react'
import crossIcon from './assets/times-black.svg'

const isClickInsideRectangle = (e: MouseEvent, element: HTMLElement) => {
  const r = element.getBoundingClientRect()

  return (
    e.clientX > r.left &&
    e.clientX < r.right &&
    e.clientY > r.top &&
    e.clientY < r.bottom
  )
}

type Props = {
  isOpened: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

const DialogModal = ({
  isOpened,
  onClose,
  children
}: Props) => {
  const ref = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (isOpened) {
      const dialog = ref.current
      if (dialog) {
        dialog.showModal()
        dialog.focus()
      }
      document.body.classList.add('basketModalOpen') // prevent bg scroll
    } else {
      // Need to fix tests
      if (typeof ref.current?.close === 'function') {
        ref.current?.close()
      }
      document.body.classList.remove('basketModalOpen')
    }
  }, [isOpened])

  return (
    <dialog className="basketModal"
      ref={ref}
      onCancel={onClose}
      onClick={(e) =>
        ref.current && !isClickInsideRectangle(e, ref.current) && onClose()
      }
    >
      <div className="closeModalButton-container">
        <button onClick={onClose} className="closeModalButton">
          <img src={crossIcon} alt="close modal" className="icon closeModalButton-icon" width="20" height="20" loading="lazy" />
        </button>
      </div>
      {children}
    </dialog>
  )
}

export default DialogModal
